import React, { useEffect, useState, useCallback } from 'react'
import Alert from './Alert';
import N from '../assets/events.json';

export default function Notifications(props) {
    const val = parseInt(props.length);
    const [alerts, setAlerts] = useState([]);

    const initData = useCallback(() => {
        var alertsData = [];
        for (let i = 0; i < N.length; i++) {
            var now = new Date();
            if (new Date(N[i].endDateTime) >= now) {
                alertsData.push(
                    <Alert key={N[i].key} timeRange={N[i].timeRange} dateRange={N[i].dateRange} innerText={N[i].innerText} title={N[i].title} ></Alert>
                )
            }
            //IF TBD STILL SHOW IN UPCOMING
            if (N[i].endDateTime === "TBD") {
                alertsData.push(
                    <Alert key={N[i].key} timeRange={N[i].timeRange} dateRange={N[i].dateRange} innerText={N[i].innerText} title={N[i].title} ></Alert>
                )
            }
        }
        if (!isNaN(val)) {
            alertsData = alertsData.slice(0, val);
        }
        setAlerts(alertsData);
    }, [val])

    useEffect(() => {
        initData();
    }, [initData])

    return (
        <div>
            <hr />
            {alerts}
        </div>
    )
}
